import type { VoidFunctionComponent } from 'react';
import Button from '../generic/Button';
import { useDialogContext } from '../../contexts/DialogContext';
import { post } from '../../redux/api';
import type { ReanalyzeQuickImportRequest } from '../../../typings/api';
import useAsyncStatus from '../../hooks/useAsyncStatus';
import Text from '../generic/Text';

/**
 * Shows a button to trigger re-analysis of quick-imported projects.
 */
export const ReanalyzeQuickImportCard: VoidFunctionComponent = () => {
  const requestStatus = useAsyncStatus();
  const { onConfirm } = useDialogContext();

  const onButtonClick = () => {
    onConfirm({
      title: 'Reanalyze all quick-imported projects',
      body: (
        <div>
          Are you sure you want to reanalyze all quick-imported projects?
        </div>
      ),
      onConfirm: async () => {
        try {
          requestStatus.onPending();
          await post<ReanalyzeQuickImportRequest, Record<string, never>>(
            '/api/organizations/reanalyze-quick-imports',
            { },
          );
          requestStatus.onSuccess();
        } catch (e) {
          requestStatus.onError(e as Error);
        }
      },
    });
  };

  return (
    <div className="card">
      <Text.H4>Re-Analyze Quick Import</Text.H4>
      <Text.Paragraph>
        This will queue re-analysis of all quick-imported projects for this
        organization, regardless of whether they used V1 or V2 of quick-import
        originally.
      </Text.Paragraph>
      <Button onClick={onButtonClick}>
        Re-Analyze
      </Button>
    </div>
  );
};

export default ReanalyzeQuickImportCard;
